import get from "lodash/fp/get";

const selectSkatePlayerName = get(["app", "userChoiceValues", "playerName"]);

export default selectSkatePlayerName;
